import { Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { FinancialInstitutionLender } from '@models/lender';

@Component({
	selector: 'app-institution-img',
	templateUrl: './institution-img.component.html',
	standalone: false,
})
export class InstitutionImgComponent {
	@Input() financialInstitution: FinancialInstitutionLender;

	public ICON = ICON;
}
